import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Link, Typography } from "@mui/material";
import { RightContainerStyled } from "../../assets/styles/theme";
import WarningIcon from "@mui/icons-material/Warning";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface NotAuthorizedComponentProps {}

const NotAuthorizedComponent: React.FC<NotAuthorizedComponentProps> = ({}) => {
  const navigate = useNavigate();

  const redirectPreviousScreen = () => {
    navigate("/file-list");
  };

  return (
    <RightContainerStyled className="d-flex align-items-center justify-content-center">
      <Box className="errorWrapper d-flex align-items-center flex-direction-column">
        <WarningIcon color="error" fontSize="large" sx={{ mb: 2, mt: 2 }} />
        <Typography
          variant="h1"
          component="h1"
          className=""
          color="error"
          sx={{ mb: 1 }}
        >
          Not Authorized
        </Typography>
        <Typography variant="body2" className="fs-16" sx={{ mb: 2 }}>
          You are not authorized to access this page.
        </Typography>      
        <Button variant="contained" startIcon={<ArrowBackIcon />} className="btn-clearfilter" onClick={() => redirectPreviousScreen()} sx={{ mb: 1 }}>
          Go Back
        </Button>
      </Box>
    </RightContainerStyled>
  );
};

export default NotAuthorizedComponent;
